import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import { Radio } from 'antd';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';
import { capitalizeFirstLetter } from 'utils/general';
import { ButtonGroup } from './styled';
import Image from 'global/Image';

interface NotificationTabProps {
  list?: Array<any>;
  type?: string;
}

function NotificationTab({ list, type }: NotificationTabProps) {
  const tab = useNotificationData((store) => store.tab);
  const changeTab = useNotificationData((store) => store.changeTab);

  const onClickTab = (tabName) => () => {
    changeTab(tabName);
  };

  if (type === 'text') {
    return (
      <ButtonGroup value={tab}>
        {list.map(({ name }) => (
          <Radio.Button
            value={name}
            onClick={onClickTab(name)}
            checked={tab === name}
            key={`tab-${tab}`}
          >
            {capitalizeFirstLetter(name)}
          </Radio.Button>
        ))}
      </ButtonGroup>
    );
  }

  return (
    <>
      {list.map(({ className, name }) => (
        <IconWrapper key={className} size="30px" onClick={onClickTab(name)}>
          {tab === name ? (
            <Image src={`/icon/notification/icon-${name}-active.svg`} />
          ) : (
            <Image src={`/icon/notification/icon-${name}.svg`} />
          )}
        </IconWrapper>
      ))}
    </>
  );
}

export default NotificationTab;
